import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useDeleteSubject = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => adminApi.deleteSubject(id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["subjects"],
            });
        },
    });
};
